/**
 * The formula AST and the value domain (`specs/M2-formula.md` §3).
 *
 * A monday formula is **dynamically typed**: `IF({status}="Won", "-", ROUND(...))` returns a
 * string in one branch and a number in the other, and that is legal `[for§1]`. So a value is
 * a number, a string, a boolean, a date, or the error box — never a union the parser has to
 * resolve up front.
 */
export function isFormulaError(value) {
    return typeof value === 'object' && value !== null && value.kind === 'error';
}
export function isFormulaDate(value) {
    return typeof value === 'object' && value !== null && value.kind === 'date';
}
export function formulaError(code, message) {
    return { kind: 'error', code, message };
}
/** monday's own wording, measured in the sandbox capture. */
export function unknownColumnError(name) {
    return formulaError('unknown_column', `A column named "${name}" doesn't exist in this board.`);
}
//# sourceMappingURL=ast.js.map